import type { ElementType } from "react";
import { ButtonIcon } from "./ButtonIcon";
import { BaseButton } from "./index";
import type { ButtonProps, IconButtonProps } from "./types";

export const IconButton = <C extends ElementType = "button">(
  props: IconButtonProps<C>,
) => {
  return (
    <BaseButton<C>
      {...(props as ButtonProps<C>)}
      startIcon={undefined}
      endIcon={undefined}
      spinnerPosition="center"
      isIcon={true}
      aria-label={props["aria-label"] || "Icon button"}
    >
      <ButtonIcon
        size={props.size || "sm"}
        icon={props.children || props.content}
      />
    </BaseButton>
  );
};
